import React from "react";
import "./Login.css";

const LoginInput = ({ type, value, setValue, text }) => {
    return (
        <div className="form-group">
            <label>{text}</label>
            <input
                type={type}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="form-control"
            />
        </div>)
};

export default LoginInput;
